module.exports = __webpack_public_path__ + "5785cb3efdd2e3b3315d1c0ebcab948b.png";